import http from "./http-common"
import {Participant} from "../types/domain";

/**
 * Service class for the Participant type
 * @author KMU
 */
class ParticipantService {
    url = `/participants/`
    getAll() {
        return http.get<Array<Participant>>(this.url + `getAll`);
    }

    get(id: number) {
        return http.get<Participant>(this.url + `${id}`);
    }

    /**
     * Get all Participants of a ServiceCenter with the given name
     * @param name name of the ServiceCenter
     * @return list of Participant entities
     */
    getByServiceCenterName(name: string) {
        return http.get<Array<Participant>>(this.url + `getByServiceCenterName?name=${encodeURIComponent(name)}`);
    }

    /**
     * Create a participant.
     * @param data participant to create.
     */
    create(data: Participant) {
        return http.post<Participant>(this.url + `create`, data);
    }

    /**
     * Update a participant.
     * @param data participant to update.
     * @param id of the participant.
     */
    update(data: Participant, id: number) {
        return http.put<Participant>(this.url + `${id}`, data);
    }

    /**
     * Delete a participant.
     * @param id of the participant to delete.
     */
    delete(id: number) {
        return http.delete<Participant>(this.url + `${id}`);
    }
}

export default new ParticipantService();